var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-video-mobile",class:[_vm.theme ? 'button-video-mobile--theme-' + _vm.theme : null]},[_c('ButtonVideo',_vm._b({},'ButtonVideo',_vm.buttonProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }